import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-584ec1f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-options-container" }
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "button-container" }
const _hoisted_5 = { class: "button-text" }
const _hoisted_6 = { class: "button-text" }
const _hoisted_7 = { class: "button-text" }

import { ref, watch, onMounted } from "vue";
import { DxTooltip } from "devextreme-vue/tooltip";


export default /*#__PURE__*/_defineComponent({
  __name: 'select-option',
  props: {
  /**
   * The title or heading associated with the component.
   * @type {string}
   * @required
   */
  title: {
    type: String,
    required: true,
  },
  /**
   * Label for the first select box.
   * @type {string}
   * @required
   */
  selectBoxOneText: {
    type: String,
    required: true,
  },
  /**
   * Label for the second select box.
   * @type {string}
   * @required
   */
  selectBoxTwoText: {
    type: String,
    required: true,
  },
  /**
   * Label for the third select box (optional).
   * @type {string}
   * @default ''
   */
  selectBoxThreeText: {
    type: String,
    default: "",
  },
  /**
   * Width of the component.
   * @type {string}
   * @default '260px'
   */
  width: {
    type: String,
    default: "260px",
  },
  /**
   * Determines whether to use a tooltip.
   * @type {boolean}
   * @default false
   */
  useToolTip: {
    type: Boolean,
    default: false,
  },
  /**
   * Tooltip ID for accessibility or referencing.
   * @type {string}
   * @default ''
   */
  toolTipId: {
    type: String,
    default: "",
  },
  /**
   * Tooltip target element ID.
   * @type {string}
   * @default ''
   */
  toolTipTarget: {
    type: String,
    default: "",
  },
  /**
   * Determines whether the title should be in bold font.
   * @type {boolean}
   * @default false
   */
  boldTitle: {
    type: Boolean,
    default: false,
  },
  /**
   * Determines whether an item should be selected by default.
   * @type {boolean}
   * @default true
   */
  selectedByDefault: {
    type: Boolean,
    default: true,
  },
  /**
   * Numeric value associated with the selected item.
   * @type {number}
   * @default 2
   */
  value: {
    type: Number,
    default: 2,
  },
  /**
   * Determines whether to show an asterisk (typically for required fields).
   * @type {boolean}
   * @default false
   */
  showAsterisk: {
    type: Boolean,
    default: false,
  },
  /**
   * Spacing style for the title section (e.g., "space-between", "center").
   * @type {string}
   * @default 'space-between'
   */
  titleSpacing: {
    type: String,
    default: "space-between",
  },
},
  emits: ["buttonSelected"],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "3d09c65f": (props.width),
  "a9c07fdc": (props.titleSpacing)
}))





const firstSelected = ref(false);
const secondSelected = ref(props.selectedByDefault);
const thirdSelected = ref(false);

const buttonSelected = () => {
  firstSelected.value = true;
  secondSelected.value = false;
  thirdSelected.value = false;
  emit("buttonSelected", 1);
};

const secondButtonSelected = () => {
  firstSelected.value = false;
  secondSelected.value = true;
  thirdSelected.value = false;
  emit("buttonSelected", 2);
};

const thirdButtonSelected = () => {
  firstSelected.value = false;
  secondSelected.value = false;
  thirdSelected.value = true;
  emit("buttonSelected", 3);
};

// If prior to the component being mounted, the value changes form the default value,
// the component reflects this

onMounted(() => {
  if (props.value == 1) {
    firstSelected.value = true;
    secondSelected.value = false;
    thirdSelected.value = false;
  } else if (props.value == 3) {
    firstSelected.value = false;
    secondSelected.value = false;
    thirdSelected.value = true;
  } else if (props.value == -1) {
    firstSelected.value = false;
    secondSelected.value = false;
    thirdSelected.value = false;
  }
});

// The value of the select box can be changed from outside the component and when this happens,
// the correct button must be displayed

watch(
  () => props.value,
  () => {
    if (props.value == 1) {
      firstSelected.value = true;
      secondSelected.value = false;
      thirdSelected.value = false;
    } else if (props.value == 2) {
      firstSelected.value = false;
      secondSelected.value = true;
      thirdSelected.value = false;
    } else if (props.value == 3) {
      firstSelected.value = false;
      secondSelected.value = false;
      thirdSelected.value = true;
    } else if (props.value == -1) {
      firstSelected.value = false;
      secondSelected.value = false;
      thirdSelected.value = false;
    }
  },
);

const screeWidth = ref(screen.width);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: _normalizeClass([{ title: __props.boldTitle, asteriskVisible: props.showAsterisk }, "options-title"])
      }, _toDisplayString(props.title), 3),
      (props.useToolTip)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: "fas fa-info-circle info-icon",
            id: props.toolTipId
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        type: "button",
        onClick: buttonSelected,
        class: _normalizeClass({
          selectedButton: firstSelected.value,
          smallScreen: screeWidth.value < 769,
        })
      }, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(props.selectBoxOneText), 1)
      ], 2),
      _createElementVNode("button", {
        type: "button",
        onClick: secondButtonSelected,
        class: _normalizeClass({
          selectedButton: secondSelected.value,
          smallScreen: screeWidth.value < 769,
        })
      }, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(props.selectBoxTwoText), 1)
      ], 2),
      (props.selectBoxThreeText)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            onClick: thirdButtonSelected,
            class: _normalizeClass({
          selectedButton: thirdSelected.value,
          smallScreen: screeWidth.value < 769,
        })
          }, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(props.selectBoxThreeText), 1)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(DxTooltip), {
      target: props.toolTipTarget,
      "show-event": "mouseenter",
      width: "275px",
      "hide-event": "mouseleave"
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "tooltip-content")
      ]),
      _: 3
    }, 8, ["target"])
  ]))
}
}

})